import type { $Fetch } from 'ofetch';
import type { ActivityGateway, ListActivitiesParams } from '@/application/port/out/ActivityGateway';
import type { Activity } from '@/domain/model/Activity';
import type { Page } from '@/domain/model/Page';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

const ROOT = '/api/v1/commerce/activities';

/** HTTP gateway de Activities (log CRM). Authority BE: `commerce:activity:read`. */
export class HttpActivityGateway implements ActivityGateway {
  constructor(private readonly client: $Fetch) {}

  async list(params: ListActivitiesParams): Promise<Page<Activity>> {
    const query: Record<string, string | number> = { page: params.page, size: params.size };
    if (params.tipo) query.tipo = params.tipo;
    if (params.leadId) query.leadId = params.leadId;
    if (params.opportunityId) query.opportunityId = params.opportunityId;
    if (params.autorUserId) query.autorUserId = params.autorUserId;
    const res = await this.client<ApiResponse<Page<Activity>>>(ROOT, { method: 'GET', params: query });
    assertApiSuccess(res);
    return res.data;
  }
}
